// 'teacher' namespace — keys are prefixed 'teacher.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'teacher.listTitle': 'Мне поделились',
  'teacher.listSubtitle': 'Работы, которые ученики явно открыли вам для проверки.',
  'teacher.notTeacher': 'Раздел для преподавателей',
  'teacher.notTeacherText': 'У вашей учётной записи нет роли преподавателя. Её назначает администратор.',
  'teacher.featureOff': 'Функция «преподаватель» сейчас выключена администратором — новые работы могут не появляться.',
  'teacher.emptyTitle': 'Пока никто не поделился работой',
  'teacher.emptyText': 'Ученики делятся конкретными попытками сами, по одной. Как только кто-то откроет вам работу, она появится здесь. Доступ можно отозвать в любой момент.',
  'teacher.attemptsN': 'работ: {n}',
  'teacher.untitled': 'Без названия',
  'teacher.sharedOn': 'открыто {date}',
  'teacher.canComment': 'комментарии',
  'teacher.canScore': 'оценки',
  'teacher.backToList': 'Все работы',
  'teacher.revokedTitle': 'Доступ отозван',
  'teacher.revokedText': 'Ученик закрыл доступ к этой работе (или она удалена). Ваши прежние отзывы сохранены у ученика.',
  'teacher.immutableNotice': 'Вы видите оригинальную рукопись и текст, подтверждённый учеником. Их нельзя изменить — ваши оценки и комментарии сохраняются отдельно.',
  'teacher.noPages': 'В работе нет страниц.',
  'teacher.prevPage': 'Предыдущая страница',
  'teacher.nextPage': 'Следующая страница',
  'teacher.pageOf': 'Стр. {n} из {total}',
  'teacher.zoomIn': 'Увеличить',
  'teacher.zoomOut': 'Уменьшить',
  'teacher.fit': 'По ширине',
  'teacher.handwritingPage': 'Рукопись, страница {n}',
  'teacher.taskPrompt': 'Задание',
  'teacher.confirmedText': 'Текст ученика',
  'teacher.rawOcr': 'Исходное распознавание',
  'teacher.showRaw': 'Распознавание',
  'teacher.version': 'версия {v}',
  'teacher.noTranscript': 'Ученик ещё не подтвердил распознанный текст.',
  'teacher.fragment': 'Фрагмент',
  'teacher.clearFragment': 'Сбросить выделение',
  'teacher.commentFragment': 'Комментировать фрагмент',
  'teacher.selectHint': 'Выделите часть текста, чтобы оставить комментарий к фрагменту.',
  'teacher.aiEvaluation': 'Автоматическая проверка',
  'teacher.noEvaluation': 'Автоматической оценки пока нет.',
  'teacher.evaluationFailed': 'Последняя автоматическая проверка завершилась ошибкой.',
  'teacher.metric.chars': 'Буквы',
  'teacher.metric.words': 'Слова',
  'teacher.metric.accents': 'Ударения',
  'teacher.metric.issues': 'Замечаний',
  'teacher.newReview': 'Ваш отзыв',
  'teacher.scores': 'Оценки по критериям',
  'teacher.scoresEmpty': 'Добавьте критерии, если хотите поставить баллы.',
  'teacher.criterion': 'Критерий',
  'teacher.score': 'Балл',
  'teacher.max': 'Максимум',
  'teacher.removeCriterion': 'Удалить критерий',
  'teacher.addCriterion': 'Добавить критерий',
  'teacher.comments': 'Комментарии',
  'teacher.commentsEmpty': 'Комментариев пока нет. Выделите фрагмент текста или добавьте общий комментарий.',
  'teacher.commentText': 'Текст комментария',
  'teacher.commentPlaceholder': 'Что стоит исправить или что получилось хорошо',
  'teacher.removeComment': 'Удалить комментарий',
  'teacher.addComment': 'Общий комментарий',
  'teacher.summary': 'Общий вывод',
  'teacher.summaryPlaceholder': 'Коротко: сильные стороны и над чем поработать',
  'teacher.submitReview': 'Отправить отзыв',
  'teacher.reviewAdditive': 'Каждый отзыв сохраняется отдельной записью.',
  'teacher.reviewSaved': 'Отзыв отправлен ученику',
  'teacher.commentsDisabled': 'Ученик открыл работу только для просмотра — комментарии и оценки отключены.',
  'teacher.myReviews': 'Мои отзывы',
  'teacher.noReviews': 'Вы ещё не оставляли отзывов к этой работе.',
  'teacher.reviewForVersion': 'к версии текста {v}',
  'teacher.err.empty': 'Добавьте оценку, комментарий или общий вывод.',
  'teacher.err.criterion': 'У каждой оценки должно быть название критерия.',
  'teacher.err.score': 'Балл должен быть числом от 0 до максимума.',
  'teacher.err.anchor': 'Фрагмент комментария не совпадает с текущим текстом — выделите его заново.',
};

const en: Record<string, string> = {
  'teacher.listTitle': 'Shared with me',
  'teacher.listSubtitle': 'Work that students have explicitly opened to you for review.',
  'teacher.notTeacher': 'For teachers',
  'teacher.notTeacherText': 'Your account does not have the teacher role. An administrator can assign it.',
  'teacher.featureOff': 'The teacher feature is currently switched off by the administrator — new shares may not appear.',
  'teacher.emptyTitle': 'Nothing has been shared yet',
  'teacher.emptyText': 'Students share specific attempts themselves, one at a time. As soon as someone shares work with you, it appears here. Access can be revoked at any time.',
  'teacher.attemptsN': '{n} attempts',
  'teacher.untitled': 'Untitled',
  'teacher.sharedOn': 'shared {date}',
  'teacher.canComment': 'comments',
  'teacher.canScore': 'scores',
  'teacher.backToList': 'All shared work',
  'teacher.revokedTitle': 'Access revoked',
  'teacher.revokedText': 'The student closed access to this work (or it was deleted). Your earlier reviews remain with the student.',
  'teacher.immutableNotice': 'You are seeing the original handwriting and the text the student confirmed. Neither can be changed — your scores and comments are stored separately.',
  'teacher.noPages': 'This attempt has no pages.',
  'teacher.prevPage': 'Previous page',
  'teacher.nextPage': 'Next page',
  'teacher.pageOf': 'Page {n} of {total}',
  'teacher.zoomIn': 'Zoom in',
  'teacher.zoomOut': 'Zoom out',
  'teacher.fit': 'Fit width',
  'teacher.handwritingPage': 'Handwriting, page {n}',
  'teacher.taskPrompt': 'Task',
  'teacher.confirmedText': 'Student text',
  'teacher.rawOcr': 'Raw recognition',
  'teacher.showRaw': 'Recognition',
  'teacher.version': 'version {v}',
  'teacher.noTranscript': 'The student has not confirmed the recognised text yet.',
  'teacher.fragment': 'Fragment',
  'teacher.clearFragment': 'Clear selection',
  'teacher.commentFragment': 'Comment on fragment',
  'teacher.selectHint': 'Select part of the text to comment on a fragment.',
  'teacher.aiEvaluation': 'Automatic check',
  'teacher.noEvaluation': 'No automatic evaluation yet.',
  'teacher.evaluationFailed': 'The latest automatic check failed.',
  'teacher.metric.chars': 'Letters',
  'teacher.metric.words': 'Words',
  'teacher.metric.accents': 'Accents',
  'teacher.metric.issues': 'Issues',
  'teacher.newReview': 'Your review',
  'teacher.scores': 'Scores by criterion',
  'teacher.scoresEmpty': 'Add criteria if you want to give points.',
  'teacher.criterion': 'Criterion',
  'teacher.score': 'Score',
  'teacher.max': 'Max',
  'teacher.removeCriterion': 'Remove criterion',
  'teacher.addCriterion': 'Add criterion',
  'teacher.comments': 'Comments',
  'teacher.commentsEmpty': 'No comments yet. Select a fragment of the text or add a general comment.',
  'teacher.commentText': 'Comment text',
  'teacher.commentPlaceholder': 'What to fix, or what went well',
  'teacher.removeComment': 'Remove comment',
  'teacher.addComment': 'General comment',
  'teacher.summary': 'Overall summary',
  'teacher.summaryPlaceholder': 'Briefly: strengths and what to work on',
  'teacher.submitReview': 'Send review',
  'teacher.reviewAdditive': 'Each review is stored as a separate record.',
  'teacher.reviewSaved': 'Review sent to the student',
  'teacher.commentsDisabled': 'The student shared this work view-only — comments and scores are disabled.',
  'teacher.myReviews': 'My reviews',
  'teacher.noReviews': 'You have not reviewed this work yet.',
  'teacher.reviewForVersion': 'for text version {v}',
  'teacher.err.empty': 'Add a score, a comment or a summary.',
  'teacher.err.criterion': 'Each score needs a criterion name.',
  'teacher.err.score': 'A score must be a number between 0 and the maximum.',
  'teacher.err.anchor': 'A comment fragment no longer matches the text — select it again.',
};

export default { ru, en };
